import slice from './reducer'

export const { removeOne, removeMany, addOne } = slice.actions

export default slice.reducer
